import type { AllRouteEndpoints } from "../routeTypes";
export const archiveQueryBuilderReportCacheKeys: AllRouteEndpoints[] = [];
